module.exports = __webpack_public_path__ + "static/img/run_di.6948d4d7.png";